import { NgxLoggerLevel } from 'ngx-logger';

export const ownerEnvironment = {
  development: true,
  enableMedicalRecordsV2: true,

  apiUrl: 'https://dev.api.petszelconnectbackend.petszel.com/',
  logger: {
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR,
    disableConsoleLogging: false,
  },
};
